import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100% - 62px);
  min-height: calc(100% - 62px);
`;

export const Content = styled.div`
  display: flex;
  height: calc(100%);
  /* min-height: calc(100% - 62px); */
  margin-top: 90px;
`;
